import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';

import * as fromGlobalStore from '../../stores/global';

@Component({
  selector: 'frodo-mobile-layout',
  templateUrl: './mobile-layout.component.html',
  styleUrls: ['./mobile-layout.component.scss'],
})
export class MobileLayoutComponent implements OnInit {
  title = '';
  isBackButtonDisabled = false;
  apexlogoUrl = 'assets/logo.png';
  isLoading$ = this.store.select(fromGlobalStore.selectIsLoading);

  readonly spinnerConfig = {
    colorSpinner: '#F8971D',
    src: './../../../../assets/timer.svg',
    diameter: 100,
    strokeWidth: 8,
    spinnerType: 'small',
  };

  constructor(private router: Router, private store: Store, private location: Location) {}

  ngOnInit() {
    this.setTitleFromRoute();

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.setTitleFromRoute();
    });
  }

  private setTitleFromRoute() {
    let activated = this.router.routerState.root;

    while (activated.firstChild) {
      activated = activated.firstChild;
    }

    this.title = activated.snapshot.data['title'];
    this.isBackButtonDisabled = activated.snapshot.data['isBackButtonDisabled'];
  }

  onGoBack(): void {
    this.location.back();
  }
}
